import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ManageUsersService } from 'src/app/services/manage-users.service';
import { MyprofileService } from 'src/app/services/myprofile.service';
import { Entity } from 'src/app/models/entity/Entity';
import { Group } from 'src/app/models/group/group';
import { AddUserModel } from 'src/app/models/user/add-user';
import { Observable } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { first } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { UserTypeEnum } from 'src/app/models/user/enum/UserTypeEnum';
import { MatDialog } from '@angular/material/dialog';
import { MembershipInfo } from 'src/app/models/user/membershipInfo';
import { SubscriptionTypeEnum } from 'src/app/models/user/enum/SubscriptionTypeEnum';
import { SubscribtionStatusEnum } from 'src/app/models/user/enum/SubscribtionStatusEnum';
import { CreateUserModelComponent } from 'src/app/modules/manageusers/create-user-model/create-user-model.component';
import { IconTypeEnum } from 'src/app/modules/badges-management/models/enums/IconTypeEnum';
import { AmbassadorPromotionLevelEnum } from 'src/app/modules/ambassadors-promotion/models/enums/AmbassadorPromotionLevelEnum';
import { MemberSubscrpitionHistoryService } from 'src/app/services/member-subscrpition-history.service';
import { UserStatusEnum } from 'src/app/models/user/enum/UserStatusEnum';
@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html'
})

export class MyProfileComponent implements OnInit {
  openSideNav = false
  dataLoading = false;
  profileDataLoading = false;
  displayedColumns: string[] = ['image', 'entityName', 'cityOrCountry', 'representativeAdmin', 'joinedSince', 'tableOptions'];
  dataSource = new MatTableDataSource<Entity>();
  @ViewChild('paginator', { static: true }) paginator: any;
  @ViewChild('form') form: any;
  // userId: string = "7fc38ded-2185-4cba-974b-46deaf2edca9";
  userId: any;
  userInformation: any = {};
  @ViewChild('paginatorGroup', { static: true }) paginatorGroup: any;
  dataSourceGroup: MatTableDataSource<Group> = new MatTableDataSource<Group>();
  obs!: Observable<any>;
  totalCountGroups = 0;
  totalCountEntities = 0;
  pageNumber = 0;
  pageSize = 5;
  showErrorMsg = false;
  showModal = false;
  minDate = new Date(1950, 4, 22);
  maxDate = new Date(2002, 3, 22);
  date: any;
  UserGroupsObj: any = {
    id: '',
    pageSize: 8,
    pageNumber: 0
  };
  entitiesObj: any = {
    id: '',
    pageSize: 6,
    pageNumber: 0
  };
  userStatus: any = {
    status: 0,
    usersID: []
  }
  // update user
  public addUserForm!: UntypedFormGroup;
  countries: any;
  cities: any;
  Nationalities: any;
  enableCity = false;
  updateUser = false;
  imageSrc!: string;
  budge!: string;
  @ViewChild('fileInput') fileInput!: ElementRef;
  fileToUpload: any = {};
  fileInputValue!: string;
  formErrors: any = [];
  loading = false;
  newUserObject: AddUserModel = new AddUserModel();
  isProfile = false;
  loginUserName: any;
  entitesCount: any;
  groupCount: any;
  pageCountEntities = 0;
  pageCountGroups = 0;
  manualPageEntities!: number;
  manualPageGroup!: number;
  emailnameexist = false;
  countryKey: string = '';

  offlineLoader = false;

  maxFileSize = 0.8;
  fileTypeError = false;
  fileSizeError = false;

  isSuperAdmin = false;
  currentUser: any;

  visitorCheck = {
    visible: false,
    required: false
  };

  openSignatureForm = false;
  userTypeEnum = UserTypeEnum
  membershipInfo: MembershipInfo = new MembershipInfo
  subscriptionTypeEnum = SubscriptionTypeEnum
  subscribtionStatusEnum = SubscribtionStatusEnum
  iconTypeEnum = IconTypeEnum
  ambassadorPromotionLevelEnum = AmbassadorPromotionLevelEnum
  userStatusEnum = UserStatusEnum
  reNewSubscriptionLoading = false

  constructor(
    private dialog: MatDialog,
    public translate: TranslateService,
    private MyprofileService: MyprofileService,
    private authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private formBuilder: UntypedFormBuilder,
    private ManageUserService: ManageUsersService,
    private memberSubscrpitionHistoryService: MemberSubscrpitionHistoryService,
    private router: Router) {

    this.activatedRoute.paramMap.subscribe(params => {
      if (params.get('userId')) {
        this.userId = params.get('userId');
        this.isProfile = false;
      } else {
        this.userId = '0';
        this.isProfile = true;
      }
      this.userStatus.usersID.push(this.userId);
      this.loginUserName = authenticationService.currentUserValue.name;
      // console.log(this.loginUserName);
    });
    this.UserGroupsObj.id = this.userId;
    this.entitiesObj.id = this.userId;
    this.currentUser = this.authenticationService.currentUserValue;

  }

  ngOnInit() {
    this.CreateForm();
    this.getUser();
    this.getCountries();
    this.getNationalities();
    this.getMembershipInfo()
    this.dataSource.paginator = this.paginator;
    this.userInformation.name = '';
    this.changeDetectorRef.detectChanges();
    this.dataSourceGroup.paginator = this.paginatorGroup;
    this.obs = this.dataSourceGroup.connect();


    // Refresh all page
    this.MyprofileService.refreshDetails.subscribe(data => {
      if (data) { this.getUser() }
    });
  }
  GoOffline(status) {
    this.offlineLoader = true;
    this.MyprofileService.GoOffline(status).subscribe(
      data => {
        this.offlineLoader = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.success'),
          text: '',
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.ok')
        });
        this.getUser();
      },
      error => {
        console.log('Try again!, ' + error);
      });
  }
  clearDate(event) {
    event.stopPropagation();
    this.date = null;
  }

  logout() {
    this.authenticationService.logout();
    // this.router.navigate(['/login']);
  }
  getUser() {
    this.profileDataLoading = true;
    this.MyprofileService.GetUser(this.userId).subscribe(
      data => {
        this.userInformation = data;
        this.userStatus.status = data.status;
        if (data.status == 1) {
          this.userStatus.status = 2;
        } else if (data.status == 2) {
          this.userStatus.status = 1;
        } else if (data.status == 0) {
          this.userStatus.status = 1;
        }
        this.authenticationService.getUserProfile();

        if (this.isProfile) {
          if (this.currentUser.role == 'SuperAdmin') {
            this.isSuperAdmin = true;
          } else {
            this.isSuperAdmin = false;
          }
        }

        this.profileDataLoading = false;
      },
      error => {

        this.profileDataLoading = false;
        console.log('Try again!, ' + error);
      });
  }

  deleteItem() {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousure'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        this.ManageUserService.deleteUser(this.userId).subscribe(
          data => {
            Swal.fire({
              title: this.translate.instant('swalMsg.deletededsuccessfuly'),
              // text: this.translate.instant('swalMsg.deletededsuccessfuly'),
              icon: 'success',
              confirmButtonText: this.translate.instant('swalMsg.ok')
            });
            this.router.navigate(['admin/manageusers']);
          },
          error => {
            console.log('Try again!, ' + error);
          });
      }
    });
  }
  changeUserStatus() {
    //  console.log(this.userStatus);
    this.ManageUserService.deactivateUser(this.userStatus).subscribe(
      result => {
        // console.log(result);
        this.getUser();
        this.getMembershipInfo()
      }
      , error => {
        if (error && error.detail) {
          Swal.fire({
            title: this.translate.instant('swalMsg.Failed'),
            text: error.detail,
            icon: 'error',
            confirmButtonText: this.translate.instant('swalMsg.ok')
          });
        }
        console.error(error);
      }
      , () => {
      }
    );
  }

  initName(name) {
    var initials = name.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    return initials;
  }
  // custom modal
  open() {
    const formModalBody = document.getElementById('formModalBody');
    if (formModalBody) {
      formModalBody.scrollTop = 0;
    }
    this.showModal = true;
    this.updateUser = false;
    // this.addUserForm.controls.emailControl.enable();
    this.addUserForm.controls.userName.enable();
  }
  emailmodelChanged(event, userId) {
    // console.log("email is", event);
    this.authenticationService.checkEmail(event, this.userId)
      .pipe(first())
      .subscribe(
        data => {
          console.log('data is!, ' + data);

          if (data) {
            this.emailnameexist = false;
          } else {
            this.emailnameexist = true;
          }

        },
        error => {
          console.log('Try again!, ' + error);
          this.emailnameexist = false;
        });
  }
  closeModal() {
    this.showModal = false;
    this.updateUser = false;
    this.addUserForm.reset();
    this.form.resetForm();
    this.imageSrc = this.budge = '';
    this.addUserForm.controls.gender.setValue('f');
    this.addUserForm.controls.userTypeEnum.setValue(UserTypeEnum.Ambassador);
    // this.addUserForm.controls.emailControl.enable();
    this.addUserForm.controls.userName.enable();
  }
  CreateForm() {
    this.addUserForm = this.formBuilder.group({
      emailControl: new UntypedFormControl('', [
        Validators.required,
        Validators.email,
      ]),
      userName: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_-]{2,15}$'),
      ]),
      fullnameControl: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^(?=.*[a-zA-Z])[a-zA-Z0-9 _-]+$')
      ]),
      nameControl: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern('^(?=.*[\u0600-\u06FF])[\u0600-\u06FF0-9 _-]+$')
      ]),
      // extentionControl: new FormControl('', [
      //   Validators.required,
      //   Validators.pattern('^((\\+91-?)|0)?[0-9]{2,4}$')
      // ]),
      phoneNumberControl: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^((\\+91-?)|0)?[0-9]{1,12}$')
      ]),
      // NationalitiesControl: new UntypedFormControl('', Validators.required),
      countryControl: new UntypedFormControl('', Validators.required),
      cityControl: new UntypedFormControl('', Validators.required),
      dateOfBirth: new UntypedFormControl('', Validators.required),
      identityNumber: new UntypedFormControl('', Validators.required),
      // jobTitleControl: new UntypedFormControl('', Validators.required),
      gender: new UntypedFormControl('f', Validators.required),
      userTypeEnum: new UntypedFormControl(UserTypeEnum.Ambassador, Validators.required),
      // employer: new UntypedFormControl('', [
      //   Validators.required
      // ]),
      // workLocationControl: new UntypedFormControl('', [
      //   Validators.required
      // ]),
      isVisitor: new UntypedFormControl(false)
    });
  }
  setFormFieldsValues(addUserFormValue) {
    this.newUserObject = {
      id: this.userId,
      email: addUserFormValue.emailControl,
      username: addUserFormValue.userName,
      fullName: addUserFormValue.fullnameControl,
      arabicName: addUserFormValue.nameControl,
      countryKey: this.countryKey,
      // extention: addUserFormValue.extentionControl,
      phoneNumber: addUserFormValue.phoneNumberControl,
      // nationalityId: addUserFormValue.NationalitiesControl,
      countryId: addUserFormValue.countryControl,
      cityId: addUserFormValue.cityControl,
      // jobTitle: addUserFormValue.jobTitleControl,
      profilePhoto: '',
      birthdate: addUserFormValue.dateOfBirth,
      identityNumber: addUserFormValue.identityNumber,
      gender: addUserFormValue.gender,
      userTypeEnum: addUserFormValue.userTypeEnum,
      status: 0,
      joinedDate: '2020-04-22T10:34:50.783Z',
      lastLoginDate: '2020-04-22T10:34:50.783Z',
      password: '12345678910',
      confirmPassword: '12345678910',
      // employer: addUserFormValue.employer,
      // workLocation: addUserFormValue.workLocationControl,
      isVisitor: false
    };
    if (addUserFormValue.dateOfBirth !== this.userInformation.birthdate) {
      this.newUserObject.birthdate = this.datePlusDay(addUserFormValue.dateOfBirth);
    }
  }
  openUpdateForm() {
    // const userId = user.userID;
    // this.updateSelectedUser = user;
    // console.log(this.userId);
    this.CheckIsVisitor();
    this.openUpdate()
  }
  openUpdate() {
    const dialogRef = this.dialog.open(CreateUserModelComponent, {
      width: '550px',
      data: { record: { userID: this.userId }, isProfile: this.isProfile },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getUser();
        this.getMembershipInfo();
      }
    });

  }
  hasError(controlName: string, errorName: string) {
    return this.addUserForm.controls[controlName].hasError(errorName);
  }
  CheckIsVisitor() {
    this.authenticationService.CheckIsVisitor()
      .subscribe(data => {
        this.visitorCheck = data;
      }, error => {
        console.log(error);
      });
  }
  getCountries() {
    this.ManageUserService.getCounties().subscribe(
      data => {
        this.countries = data;
        // console.log("data is ", this.countries);
      },
      error => {
        // console.log('Try again!, ' + error);
      });
  }
  getNationalities() {
    this.ManageUserService.getNationalities().subscribe(
      data => {
        this.Nationalities = data;
        // console.log("data is ", this.Nationalities);
      },
      error => {
        console.log('Try again!, ' + error);
      });
  }
  getCountryId(countryId, updateCity = undefined) {
    let cId = countryId.value;

    // var countryIndex = this.countries.find(e=> e.id == cId);
    // this.countryKey = countryIndex.countryKey;

    if (updateCity !== undefined) {
      cId = countryId;
    }

    var countryIndex = this.countries.find(e => e.id == cId);
    if (countryIndex && countryIndex.countryKey) {
      this.countryKey = countryIndex.countryKey;
    }

    if (countryId.value !== '') {
      this.enableCity = true;
      // console.log(this.enableCity);
      this.ManageUserService.getCities(cId).subscribe(
        data => {
          this.cities = data;
          if (updateCity !== undefined) {
            this.addUserForm.controls.cityControl.setValue(updateCity);
          }
          // console.log("data is ", this.cities);
        },
        error => {
          console.log('Try again!, ' + error);
        });
    }
  }

  validateFile(file: File): any {
    if (this.fileType(file.name)) {
      this.fileTypeError = false;
      if ((file.size / (1024 * 1024)) <= this.maxFileSize) {
        this.fileSizeError = false;
      } else {
        this.fileSizeError = true;
        return false;
      }
    } else {
      this.fileTypeError = true;
      return false;
    }
    return true;
  }
  fileType(fileName): any {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'jpeg':
      case 'jpg':
        return 'jpg';
      case 'png':
        return 'png';
      default:
        return false;
    }
  }
  makeBudge(event) {
    this.budge = this.initName(event.target.value);
  }
  saveUser() {
    console.log(this.addUserForm);
    if (this.addUserForm.valid && !this.fileSizeError && !this.fileTypeError) {
      this.loading = true;
      this.executeUserSubs(this.addUserForm);
    }
  }
  executeUserSubs(formValues) {
    // console.log(formValues.getRawValue());
    this.setFormFieldsValues(formValues.getRawValue());
    // console.log("photo", this.fileToUpload);
    this.ManageUserService.saveUser(this.updateUser, this.newUserObject, this.fileToUpload).subscribe(
      data => {
        this.loading = this.showModal = this.showErrorMsg = false;
        this.imageSrc = '';
        this.addUserForm.controls.gender.setValue('f');
        this.addUserForm.controls.userTypeEnum.setValue(UserTypeEnum.Ambassador);
        this.closeModal();
        this.getUser();
        // this.authenticationService.getUserProfile();
      },
      error => {
        // console.error(error);
        this.loading = false;
        this.formErrors = error;
        // console.log(this.formErrors);
        this.showErrorMsg = true;
      },
      () => {

      });
  }

  datePlusDay(date) {
    let newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 1);
    return newDate;
  }
  dateMinusDay(date) {
    let newDate = new Date(date);
    newDate.setDate(newDate.getDate() - 1);
    return newDate;
  }


  getMembershipInfo() {
    this.dataLoading = true;
    let data: any = {}
    if (this.userId != 0) data.userId = this.userId
    this.dataLoading = true;
    this.ManageUserService.getMembershipInfo(data).subscribe(
      (res: MembershipInfo) => {
        this.dataLoading = false;
        this.membershipInfo = res;
      }, error => {
        console.log('Faild');
      });
  }

  print() {
    window.print();
  }

  renewSubscription() {
    this.reNewSubscriptionLoading = true
    this.memberSubscrpitionHistoryService.reNewSubscription({ amount: 0 }).subscribe(
      (res) => {
        this.reNewSubscriptionLoading = false
        Swal.fire({
          title: this.translate.instant('swalMsg.success'),
          text: '',
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.ok'),
        }).then((result) => {
          this.getUser();
        });
      }, error => {
        console.log('Faild');
        this.reNewSubscriptionLoading = false
      });

  }

  viewHistory() {
    // this.trainerId = trainerId;
    this.openSideNav = true;


  }

  closeSidenav(e) {
    this.openSideNav = false;
  }

}
